import { payerTypeConstants } from "constants/payer";
import { InputSwitch } from "primereact/inputswitch";
import { Controller, useFormContext } from "react-hook-form";

/**
 * CLE-2605 — when this payer is the SECONDARY on an order, does it absorb the entire balance the
 * primary left (deductible + copay + coinsurance), or only the primary's coinsurance?
 *
 * Medicaid is payer-of-last-resort, so it always absorbs everything — the backend drives that off
 * `type` rather than this column, which is why the switch renders forced-on and disabled for a
 * Medicaid payer. The toggle exists for plans that behave the same way but aren't typed Medicaid,
 * GAP plans being the case that prompted it.
 */
export function SecondaryAbsorbsFullResponsibility() {
  const { control, watch } = useFormContext();
  const isMedicaid = watch("type") === payerTypeConstants.MEDICAID;

  return (
    <div className="field col-12 p-3">
      <label
        htmlFor="secondaryAbsorbsFullResponsibility"
        className="font-medium mb-2 block"
      >
        Covers full patient balance as secondary
      </label>
      <Controller
        name="secondaryAbsorbsFullResponsibility"
        control={control}
        render={({ field }) => (
          <div className="flex align-items-center gap-2">
            <InputSwitch
              inputId="secondaryAbsorbsFullResponsibility"
              checked={isMedicaid || !!field.value}
              disabled={isMedicaid}
              onChange={(e) => field.onChange(e.value)}
            />
            <span className="text-sm text-600">
              {isMedicaid
                ? "Always on for Medicaid payers — as the secondary, Medicaid covers everything the primary leaves, so the patient owes $0."
                : "As the secondary, this payer picks up the primary's deductible and copay too — not just the coinsurance. Use for GAP plans and anything else that leaves the patient owing nothing."}
            </span>
          </div>
        )}
      />
    </div>
  );
}
